import * as React from "react";

import "./ShowLineModal.css";

import { connect } from "react-redux";

import { Modal, ModalBody, ModalHeader } from "reactstrap";

import { ILine, LineID, ILineUpdate, UserID } from "../api/APIClient";
import { RootState } from "../types";
import { toggleLineModalOpen } from "src/actions";
import ModalFooter from "reactstrap/lib/ModalFooter";
import Button from "reactstrap/lib/Button";
import {
  updateLine as updateLineAction,
  createLine as createLineAction,
  deleteLine as deleteLineAction,
} from "src/thunks";
import Loader from "src/components/Loader";
import APIError from "src/api/APIError";
import { RRuleStr } from "src/Schedule";

interface IProps {
  line?: ILine;
  isOpen: boolean;
  isLoading: boolean;
  error: APIError | null;

  toggleOpen: () => any;
  updateLine: (update: ILineUpdate) => any;
  createLine: (line: ILine) => any;
  deleteLine: (id: LineID) => any;
}

interface IState {
  line: ILine;
}

const EMPTY_LINE: ILine = {
  id: "" as LineID,
  operatorID: "" as UserID,
  operatorUsername: "",
  name: "",
  description: "",
  schedule: "" as RRuleStr,
  private: true,
};

export class ShowLineModal extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    let { line } = props;
    if (!line) {
      line = { ...EMPTY_LINE };
    }

    this.state = { line };
  }

  public componentWillReceiveProps(props: IProps) {
    if (this.props.line !== props.line) {
      let { line } = props;
      if (!line) {
        line = { ...EMPTY_LINE };
      }

      this.setState({ line });
    }
  }

  public render() {
    const { isOpen, toggleOpen, error, isLoading } = this.props;
    const { line } = this.state;

    const isNew = !this.props.line;

    return (
      <Modal className="show-line-modal" isOpen={isOpen} toggle={toggleOpen}>
        <ModalHeader toggle={toggleOpen}>
          {isNew ? "Create Line" : "Edit Line"}
        </ModalHeader>
        <ModalBody>
          <form onSubmit={this.onSubmit}>
            <button onClick={this.onClickDelete} className="delete-button">
              Delete
            </button>

            <table>
              <tbody>
                <tr>
                  <th>ID</th>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      disabled={!isNew}
                      onChange={this.onIDChanged}
                      value={line.id}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Operator ID</th>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.onOperatorIDChanged}
                      value={line.operatorID}
                    />
                  </td>
                </tr>

                <tr>
                  <th>Name</th>
                  <td>
                    <input
                      className="form-control"
                      type="text"
                      onChange={this.onNameChanged}
                      value={line.name}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Description</th>
                  <td>
                    <textarea
                      rows={5}
                      value={line.description}
                      onChange={this.onDescriptionChanged}
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <th>Schedule</th>
                  <td>
                    <textarea
                      rows={2}
                      placeholder="encoded as an ical RRULE"
                      value={line.schedule}
                      onChange={this.onScheduleChanged}
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <th>Private</th>
                  <td>
                    <input
                      type="checkbox"
                      onChange={this.onPrivateChanged}
                      checked={line.private}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </ModalBody>
        <ModalFooter>
          <div className="text-danger">
            {error ? `${error.error}: ${error.details}` : null}
          </div>
          <Loader visible={isLoading} />
          <Button onClick={this.onSubmit} color="primary">
            {isNew ? "Create" : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  private onIDChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({
      line: { ...this.state.line, id: value as LineID },
    });
  };

  private onOperatorIDChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({
      line: { ...this.state.line, operatorID: value as UserID },
    });
  };

  private onNameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({
      line: { ...this.state.line, name: value },
    });
  };

  private onDescriptionChanged = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { value } = e.currentTarget;
    this.setState({
      line: { ...this.state.line, description: value },
    });
  };

  private onScheduleChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.currentTarget;
    this.setState({
      line: { ...this.state.line, schedule: value as RRuleStr },
    });
  };

  private onPrivateChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.currentTarget;
    this.setState({
      line: { ...this.state.line, private: checked },
    });
  };

  private onClickDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const { line, deleteLine } = this.props;
    if (!line) {
      return;
    }

    if (!confirm("Really delete?")) {
      return;
    }

    deleteLine(line.id);
  };

  private onSubmit = () => {
    const { line, updateLine, createLine } = this.props;
    const newLine = this.state.line;

    if (line) {
      return updateLine({
        id: line.id,
        operatorID: newLine.operatorID,
        name: newLine.name,
        description: newLine.description,
        schedule: newLine.schedule,
        private: newLine.private,
      });
    } else {
      return createLine(newLine);
    }
  };
}

export const ShowLineContainer = connect(
  ({ lines }: RootState) => ({
    isOpen: lines.modalOpen,
    line: lines.selectedID
      ? lines.data.find(p => p.id === lines.selectedID)
      : undefined,
    isLoading: lines.isLoading,
    error: lines.error,
  }),
  dispatch => ({
    toggleOpen: () => dispatch(toggleLineModalOpen()),
    updateLine: (update: ILineUpdate) =>
      dispatch<any>(updateLineAction(update)),
    createLine: (line: ILine) => dispatch<any>(createLineAction(line)),
    deleteLine: (id: LineID) => dispatch<any>(deleteLineAction(id)),
  })
)(ShowLineModal);

export default ShowLineContainer;



// WEBPACK FOOTER //
// ./src/pages/ShowLineModal.tsx